import { createSlice } from '@reduxjs/toolkit'
import { getAllMaterialIds, getVendors } from '../../apis'
import { getFabricVendors } from '../fabricManagement/api'

export const headerSlice = createSlice({
    name: 'header',
    initialState: {
        pageTitle: "",  // current page title state management
        noOfNotifications : 15,  // no of unread notifications
        newNotificationMessage : "",  // message of notification to be shown
        newNotificationStatus : 1,   // to check the notification type -  success/ error/ info
        newNotificationTimeout: "",
        currentLanguage: "",
        vendorsData: [],
        fabricData: [],
        fabricVendorData: []
    },
    reducers: {
        setPageTitle: (state, action) => {
            state.pageTitle = action.payload.title
        },

        setCurrentLanguage: (state, action) => {
            state.currentLanguage = action.payload.currentLanguage
        },

        removeNotificationMessage: (state, action) => {
            state.newNotificationMessage = ""
            state.newNotificationTimeout = ""
        },

        showNotification: (state, action) => {
            state.newNotificationMessage = action.payload.message
            state.newNotificationStatus = action.payload.status
            state.newNotificationTimeout = action.payload.timeout
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getVendors.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getVendors.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.vendorsData = action.payload.data
        })
        builder.addCase(getVendors.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(getAllMaterialIds.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getAllMaterialIds.fulfilled, (state, action) => {
            state.isLoading = true;
            state.error = '';
            state.fabricData = action.payload.data
        })
        builder.addCase(getAllMaterialIds.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
        builder.addCase(getFabricVendors.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getFabricVendors.fulfilled, (state, action) => {
            state.isLoading = false;
            state.error = '';
            state.fabricVendorData = action.payload.data;
        })
        builder.addCase(getFabricVendors.rejected, (state, action) => {
            state.error = action.payload.message
            state.isLoading = false;
        })
    }
})

export const { setPageTitle, removeNotificationMessage, showNotification, setCurrentLanguage} = headerSlice.actions

export default headerSlice.reducer